import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useContentSidebarStore } from "@/stores/content-sidebar-store"

export function ContentSidebarConfirmDialog() {
  const { t } = useTranslation()
  const showConfirmDialog = useContentSidebarStore((state) => state.showConfirmDialog)
  const currentPanel = useContentSidebarStore((state) => state.currentPanel)
  const cancelPendingAction = useContentSidebarStore((state) => state.cancelPendingAction)
  const confirmPendingAction = useContentSidebarStore((state) => state.confirmPendingAction)

  const message = currentPanel?.confirmMessage

  return (
    <AlertDialog
      open={showConfirmDialog}
      onOpenChange={(open) => {
        if (!open) {
          cancelPendingAction()
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {message?.title ??
              t("common.unsaved_changes_title", { defaultValue: "Discard unsaved changes?" })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {message?.description ??
              t("common.unsaved_changes_description", {
                defaultValue:
                  "You have unsaved changes. If you continue, your current changes will be lost.",
              })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {message?.cancelLabel ?? t("common.cancel", { defaultValue: "Cancel" })}
          </AlertDialogCancel>
          <AlertDialogAction onClick={confirmPendingAction}>
            {message?.confirmLabel ?? t("common.discard", { defaultValue: "Discard" })}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
